import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-398ef4b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "value"]
const _hoisted_2 = {
  key: 0,
  value: "-1"
}
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    class: _normalizeClass(['select', { block: _ctx.block }]),
    name: _ctx.name,
    value: _ctx.value,
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.Expand})` }),
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event.target.value)))
  }, [
    (_ctx.nullable)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, " なし "))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, ix) => {
      return (_openBlock(), _createElementBlock("option", {
        key: ix,
        value: ix
      }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_3))
    }), 128 /* KEYED_FRAGMENT */))
  ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_1))
}